/* eslint-disable */
import { BiMobileAlt } from "react-icons/bi";
import { AiFillBug, AiOutlineDatabase, AiFillRobot } from "react-icons/ai";
import { FaServer } from "react-icons/fa";
import { GiBrain } from "react-icons/gi";
import { LuScanFace, LuLayoutTemplate } from "react-icons/lu";

 

export const servicesData = [
     {
        id: 1,
        title: 'Mobile App Development',
        icon: <BiMobileAlt/>
     },
    {
        id: 2,
        title: 'Web Development',
        icon: <LuLayoutTemplate />
    },
    {
        id: 3,
        title: 'Deployment and server Hosting',
        icon: <FaServer />
    },
    {
         id: 4,
         title: 'Bug Fixing',
         icon: <AiFillBug />
     },
     {
         id: 5,
         title: 'Backend & DataBase Services',
         icon: <AiOutlineDatabase />
     },

     {
         id: 6,
         title: 'Computer Vision and Image Processing',
         icon: <LuScanFace />
     }, 

    {
        id: 7,
        title: 'AI Automation',
        icon: <GiBrain />
    },


     {
        id: 8,
        title: 'IoT Product Development',
        icon: <AiFillRobot />
    },
 
    // {
    //    id: 9,
    //    title: 'Video Editing',
    //    icon: <FaVideo />
    // },

    // {
    //     id: 10,
    //     title: 'Data Entry', 
    //     icon: <BsClipboardData />
    // },
    // {
    //    id: 11,
    //    title: 'Ebook Writing',
    //    icon: <FaTabletAlt />
    //},
    // {
    //     id: 12,
    //     title: 'Audio Transcription',
    //     icon: <AiFillAudio />
    // },
    // {
    //    id: 13,
    //    title: 'Blog Posting',
    //    icon: <FaRegNewspaper />
    // },

]
